/* eslint-disable max-classes-per-file */
import { ErrorBase } from 'requests/objects/_base'

/**
 * Export DTO Object
 */
export default class ExportDto {
    /**
     * @param {object} data data
     * @param {Date=} data.startDate startDate
     * @param {Date=} data.endDate endDate
     * @param {boolean=} data.isTimeExport isRubricsExport
     * @param {boolean=} data.isRubricsExport isRubricsExport
     * @param {string[]=} data.collaborators collaborators
     */
    constructor({
        startDate = null,
        endDate = null,
        isTimeExport = false,
        isRubricsExport = false,
        collaborators = [],
    } = {}) {
        this.startDate = startDate
        this.endDate = endDate
        this.isTimeExport = isTimeExport
        this.isRubricsExport = isRubricsExport
        this.collaborators = collaborators
    }
}

/**
 * Export Object used to bind error message
 */
export class ErrorExportDto extends ErrorBase {
    constructor() {
        super()
        this.startDate = ''
        this.endDate = ''
        this.isTimeExport = ''
        this.isRubricsExport = ''
        this.collaborators = ''
    }
}
